// extracted by mini-css-extract-plugin
export default {"lawyersSection":"LawyersSection_lawyersSection__uTUrF","lawyerCardsContainer":"LawyersSection_lawyerCardsContainer__GWUQi"};